function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import Calendar from './calendar';
import { ShopingCartButton } from '../../../molecules/Button';
import { PanelBody, PanelContainer, RangeContainer } from './style';

var Footer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer(props) {
    var _this;

    _classCallCheck(this, Footer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Footer).call(this, props));

    _this.shouldComponentUpdate = function (nextProps) {
      return true;
    };

    _this.handleModalClick = function () {
      _this.props.actions.show('ShoppingCartModal', _this.props);
    };

    _this.render = function () {
      return React.createElement("div", {
        className: "col-xs-12"
      }, React.createElement("div", {
        className: 'panel panel-default clearfix data-page__section__download-data-panel'
      }, React.createElement(PanelBody, null, _this.props.range && _this.props.range.current ? React.createElement(PanelContainer, null, _this.props.calendar ? React.createElement(RangeContainer, null, React.createElement(Calendar, {
        calendar: _this.props.calendar,
        countryID: _this.props.countryID,
        plotID: _this.props.plotID,
        actions: _this.props.actions,
        startDate: _this.props.range.current.length ? _this.props.range.current[0] : _this.props.range.total[0],
        endDate: _this.props.range.current.length ? _this.props.range.current[1] : _this.props.range.total[1],
        range: _this.props.range.total,
        updateBrush: _this.props.range.update,
        isMobileWidth: _this.props.isMobileWidth
      })) : '', React.createElement(ShopingCartButton, {
        color: 'gray',
        size: '30px',
        handleClick: function handleClick() {
          return _this.handleModalClick();
        }
      }, React.createElement("span", {
        className: "glyphicon glyphicon-download-alt"
      }), React.createElement("span", {
        className: "text"
      }, " ".concat(_this.props.plotDownloadText)))) : React.createElement(PanelContainer, null, _this.props.calendar ? React.createElement(RangeContainer, null, React.createElement(Calendar, {
        plotID: _this.props.plotID,
        startDate: _this.state.startDate,
        endDate: _this.state.endDate,
        isMobileWidth: _this.props.isMobileWidth
      })) : '', React.createElement(ShopingCartButton, {
        color: 'gray',
        size: '30px'
      }, React.createElement("span", {
        className: "glyphicon glyphicon-download-alt"
      }), React.createElement("span", {
        className: "text"
      }, " ".concat(_this.props.plotDownloadText)))))));
    };

    if (props.range && props.range.current && props.range.current.length) {
      // Fix me (reduce code)
      _this.state = {
        startDate: props.range.current[0],
        endDate: props.range.current[1]
      };
    } else if (props.range && props.range.total && props.range.total.length) {
      _this.state = {
        startDate: props.range.total[0],
        endDate: props.range.total[1]
      };
    } else {
      _this.state = {};
    }

    return _this;
  }

  return Footer;
}(React.Component);

export { Footer as default };
Footer.propTypes = {
  countryID: PropTypes.string,
  plotID: PropTypes.string,
  actions: PropTypes.object,
  plotCountryCode: PropTypes.string,
  range: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  plotSelectedSampleRate: PropTypes.string,
  possibleSampleRates: PropTypes.array,
  plotDownloadText: PropTypes.string,
  downloadDateRangeLabel: PropTypes.string,
  launchDownloadModal: PropTypes.func,
  isMobileWidth: PropTypes.bool,
  calendar: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};